export default (params) => ({
  trigger: {
    name: 'content_blocks.newsletter.subscribe',
    params: params,
  },
  config: {
    schema: {
      status: {
        enum: [
          'success',
          'failure',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'subscribe',
      params: {
        sub_feature: null,
        item_id: null,
      },
    },
  },
});
